import React from "react";

const Footer = () => {
  return (
    <footer
      className="bg-dark-950 border-t border-primary-900/20"
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-8 xl:col-span-1">
            <div className="flex items-center">
              <img
                src="/logo.png"
                alt="Speedr Logo"
                className="h-8 w-auto mr-3"
              />
              <span className="text-2xl font-bold text-primary-500">
                SpeedR
              </span>
            </div>
            <p className="text-sm leading-6 text-primary-300">
              Making advanced AI accessible to everyone, anywhere. No internet
              required. No compromises on privacy.
            </p>
            <div className="flex space-x-6">
              {/* Social media links can be added here */}
            </div>
          </div>
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-white">
                  Products
                </h3>
                <ul role="list" className="mt-6 space-y-4">
                  <li>
                    <a
                      href="#ai-app"
                      className="text-sm leading-6 text-primary-300 hover:text-primary-400"
                    >
                      AI App
                    </a>
                  </li>
                  <li>
                    <a
                      href="#ai-doctor"
                      className="text-sm leading-6 text-primary-300 hover:text-primary-400"
                    >
                      AI Doctor
                    </a>
                  </li>
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold leading-6 text-white">
                  Company
                </h3>
                <ul role="list" className="mt-6 space-y-4">
                  <li>
                    <a
                      href="#about"
                      className="text-sm leading-6 text-primary-300 hover:text-primary-400"
                    >
                      About
                    </a>
                  </li>
                  <li>
                    <a
                      href="#contact"
                      className="text-sm leading-6 text-primary-300 hover:text-primary-400"
                    >
                      Contact
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="text-sm leading-6 text-primary-300 hover:text-primary-400"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="text-sm leading-6 text-primary-300 hover:text-primary-400"
                    >
                      Press Release
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 border-t border-primary-900/40 pt-8 sm:mt-20 lg:mt-24">
          <p className="text-xs leading-5 text-primary-400">
            &copy; Copyright © 2026 SpeedR AI - All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
